import { render, staticRenderFns } from "./OrderClaimForm.vue?vue&type=template&id=577d6900&"
import script from "./OrderClaimForm.vue?vue&type=script&lang=ts&"
export * from "./OrderClaimForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports